import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen24Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconLockOpen24Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.552 4.383c.296-.365.816-.6 1.41-.733a5.8 5.8 0 0 1 1.258-.13h.027l.114.001a3.62 3.62 0 0 1 3.62 3.62V8H7a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-2.52-2.962v-.897a5.12 5.12 0 0 0-5.197-5.12l-.04-.001a7.2 7.2 0 0 0-1.608.166c-.715.16-1.636.497-2.248 1.252a15 15 0 0 0-.53.683 2 2 0 0 0-.103.156 1 1 0 0 0-.083.19l-.007.026-.004.015-.002.007v.004c0 .002-.001.004.733.158l-.734-.154a.75.75 0 0 0 1.399.5l.024-.035c.06-.085.194-.262.472-.605m3.176 10.968a1.5 1.5 0 1 0-1.424.018.8.8 0 0 0-.035.228v.807a.75.75 0 0 0 1.5 0v-.807a.8.8 0 0 0-.041-.246"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen24Filled);
